import { Model } from '@vuex-orm/core'
import User from './User'

export default class Department extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'departments'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      id: this.attr(null),
      name: this.attr(''),
      users: this.hasMany(User, 'department_id'),
      workers: this.attr([]),
      trafficable: this.boolean(true),
    }
  }

  get children() {
    return this.users
  }

  get icon() {
    return null
  }

  get treeId() {
    return this.id
  }
}